import {
  styled,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import {
  colors,
  defaultStyle,
  fontSize,
  fontWeight,
  lineHeight,
  margin,
  padding,
} from "theme/defaultStyle";
import FolderXIcon from "theme/icons/FolderXIcon";
import NoFiltersIcon from "theme/icons/NoFiltersIcon";

export enum EmptyStateType {
  NO_FILTERS = "no-filters",
  NO_RESULTS = "no-results",
  DEFAULT = "default",
}

interface Props {
  messages: string[];
  colSpan?: number;
  emptyStateType?: EmptyStateType;
}

const StyledTableBody = styled(TableBody)({
  padding: padding.xlarge1
});

const StyledTableCell = styled(TableCell)({
  borderLeft: defaultStyle.table.border,
  borderRight: defaultStyle.table.border,
  color: colors.grey11,
  fontSize: fontSize.xlarge2,
  lineHeight: lineHeight.large,
});

const StyledMessageContainer = styled("div")({
  marginTop: margin.small1,
});

const StyledSecondMessage = styled("div")({
  color: colors.grey09,
  fontSize: fontSize.large,
});

const StyledNoResultsMessage = styled(Typography)({
  color: colors.grey22,
  fontSize: fontSize.xlarge,
  marginTop: margin.large,
  fontWeight: fontWeight.bold1,
});

const CenteredContentWrapper = styled("div")({
  position: "sticky",
  left: 0,
  width: "100vw",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export const NO_RESULTS_FOUND = "No results found";
export const NO_FILTERS_APPLIED =
  "No search criteria have been entered. Please enter search criteria and click Apply Filters.";

const StewartTableBodyEmpty = ({ messages, colSpan, emptyStateType }: Props) => {
  const [firstMessage, secondMessage, ...remainingMessages] = messages;

  if (emptyStateType === EmptyStateType.NO_FILTERS || emptyStateType === EmptyStateType.NO_RESULTS) {
    return (
      <StyledTableBody>
        <TableRow>
          <StyledTableCell
            colSpan={colSpan}
            className="emptyCell"
            sx={{
              backgroundColor: colors.grey25,
              height: "161px",
              padding: `${padding.xxlarge1} ${padding.zero}`,
            }}
          >
            <CenteredContentWrapper>
              {emptyStateType === EmptyStateType.NO_FILTERS ? <NoFiltersIcon /> : <FolderXIcon />}

              <StyledNoResultsMessage>
                {emptyStateType === EmptyStateType.NO_FILTERS ? NO_FILTERS_APPLIED : NO_RESULTS_FOUND}
              </StyledNoResultsMessage>
            </CenteredContentWrapper>
          </StyledTableCell>
        </TableRow>
      </StyledTableBody>
    );
  }

  return (
    <StyledTableBody>
      <TableRow>
        <StyledTableCell colSpan={colSpan} className="emptyCell">
          {firstMessage}
          {secondMessage && (
            <StyledMessageContainer>
              <StyledSecondMessage>{secondMessage}</StyledSecondMessage>
            </StyledMessageContainer>
          )}
          {remainingMessages.map((message, index) => (
            <StyledMessageContainer key={index}>
              {message}
            </StyledMessageContainer>
          ))}
        </StyledTableCell>
      </TableRow>
    </StyledTableBody>
  );
};

export default StewartTableBodyEmpty;
